import { Avatar, Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useIsDesktop } from 'Hooks';
import { PurpleAlert } from 'Images';

interface IInstituteAlert {
  instituteName: string;
}

export const InstituteAlert = ({ instituteName }: IInstituteAlert) => {
  const isDesktop = useIsDesktop();
  return (
    <Stack
      direction='row'
      alignItems='center'
      gap='8px'
      sx={{
        mt: isDesktop ? '40px' : '20px',
        p: isDesktop ? '16px 24px' : '12px',
        border: '1px solid',
        borderColor: '#B7CCFF',
        borderRadius: '12px',
        bgcolor: '#E7EDFF',
      }}
    >
      <Avatar alt='' src={PurpleAlert} sx={{ width: '24px', height: '24px' }} />
      <Typography variant='body3'>
        {Dictionary[DICTIONARY.Suppliers].resultPage.therapy.therapyFrame}{' '}
        {instituteName}
      </Typography>
    </Stack>
  );
};
